module.exports = __webpack_public_path__ + "img/1-12.b1479388.png";